type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'FinancialMoviment'
const nameSource = 'financial/expenses'
const namePageTitle = 'Despesas'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Expenses',
  to: '/financial/expenses',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/expenses/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/expenses/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/expenses/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
